import { render } from "./PlumbingSetupItem.vue?vue&type=template&id=2569495d"
import script from "./PlumbingSetupItem.vue?vue&type=script&lang=js"
export * from "./PlumbingSetupItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__